import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import EmergencyFundOutcomeSummaryStepLayout
  from 'Views/Page/Content/Modal/Layouts/EmergencyFundOutcomeSummaryStepLayout/Layout';
import EmergencyFundOutcomeExpenseReviewStepLayout
  from 'Views/Page/Content/Modal/Layouts/EmergencyFundOutcomeExpenseReviewStepLayout/Layout';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const styles = (theme) => ({
  root: {},
  label: {},
  fields: {
    padding: theme.spacing(0),
  },
  group: {
    marginBottom: theme.spacing(4),
  },
});

const FacetPlanOutcomeQuickEditEmergencyFundLayout = ({
  className,
  classes,
}) => {
  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const { refreshPageContentCollection } = usePageContentContext();

  const {
    loadModalCollectionByLink,
    clearModalCollection,
  } = useModalContext();

  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

  return (
    <Box className={classNames(classes.root, className)}>
      <TitleSection />
      <EmergencyFundOutcomeExpenseReviewStepLayout className={classes.group} />
      <EmergencyFundOutcomeSummaryStepLayout className={classes.group} />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      <WhatIfStepNavigator
        isLoading={saving}
        onNext={async () => {
          const resp = await onSubmit();
          if (resp) {
            clearModalCollection();
            refreshPageContentCollection();
          }
        }}
        onPrevious={(previousLink) ? () => {
          loadModalCollectionByLink(previousLink.url());
        } : null}
      />
    </Box>
  );
};

FacetPlanOutcomeQuickEditEmergencyFundLayout.defaultProps = {
  className: '',
};

FacetPlanOutcomeQuickEditEmergencyFundLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FacetPlanOutcomeQuickEditEmergencyFundLayout);
